import { IconCheckBlack } from "@repo/assets/images";
import cx from "classnames";
const CategorySortOptions = ({
  sortOptions,
  handleSortBy,
  handleToggle,
  isDropdown,
  selectedValue
}) => {
  return <ul className={cx({
    "-mx-4 pt-3": !isDropdown
  })} data-sentry-component="CategorySortOptions" data-sentry-source-file="CategorySortOptions.jsx">
      {sortOptions?.map(option => {
      const isSelected = selectedValue === option.value;
      return <li key={option.value} className={cx({
        "border-toolbar-sort-sortBorder border-b": isDropdown
      })}>
            <label className={cx("text-toolbar-sort-text flex cursor-pointer items-center px-4 py-3 text-sm font-medium", {
          "bg-toolbar-sort-activeBg": isSelected,
          "hover:bg-toolbar-sort-activeBg": isDropdown
        })} htmlFor={option.value}>
              <input id={option.value} type="radio" onChange={() => {
            handleSortBy(option.value);
            handleToggle();
          }} name="sortby" checked={isSelected} hidden />
              {option.name}
              {isSelected && <IconCheckBlack className="text-toolbar-sort-active ms-auto fill-current" />}
            </label>
          </li>;
    })}
    </ul>;
};
export default CategorySortOptions;